<template>
  <div class="container-fluid">

    <div class="row dataTable-filters orderlines-dt-filter">
      <!-- DATE -->
      <div class="table-filter">
        <label>{{ $t('shopfloor.teamlead.dockSuggestions.selectedDate') }}</label>
        <datepicker
            monday-first
            :language="nl"
            :format="dateDisplay"
            @selected="selectedDateChanged"
            :value="selectedDate"
            id="selectedDate" input-class="form-control "/>
      </div>

      <!-- View -->
      <div class="table-filter">
        <label>{{ $t('shopfloor.teamlead.dockSuggestions.view.title') }}</label>
        <div class="option-wrapper">
          <div class="custom-control custom-radio">
            <input v-model="currentView"
                   value="loading"
                   type="radio"
                   v-on:change="viewChangeTriggered"
                   name="view"
                   id="view-loading"
                   class="custom-control-input"
            >
            <label class="custom-control-label" for="view-loading">
              <span>{{ $t(`shopfloor.teamlead.dockSuggestions.view.loading`) }}</span>
            </label>
          </div>
          <div class="custom-control custom-radio">
            <input v-model="currentView"
                   value="unloading"
                   type="radio"
                   v-on:change="viewChangeTriggered"
                   name="view"
                   id="view-unloading"
                   class="custom-control-input"
            >
            <label class="custom-control-label" for="view-unloading">
              <span>{{ $t(`shopfloor.teamlead.dockSuggestions.view.unloading`) }}</span>
            </label>
          </div>
        </div>
      </div>

      <button class="btn btn-secondary print-button" @click="printTable()">
        <i class="fa fa-print"/>
      </button>
    </div>

    <div class="table-responsive">
      <datatables
          :columns="getColumns()"
          ref="dockSuggestionsTable"
          :rows="getDockSuggestions"
          :tableClass="tableClass"
          :tableInitOptions="tableInitOptions"
          deleteClass="delete"
          :key="currentView + '-' + selectedDate.toJSON() + '-' + viewTriggers"
          :customFilters="[]"
          tableID="dock-suggestions-dt"
          v-if="getDockSuggestions"
      />
    </div>
  </div>
</template>


<script>
import {mapActions, mapGetters, mapMutations} from 'vuex';
import dataTables from '../../mixins/datatables';
import Datepicker from 'vuejs-datepicker';
import {nl} from 'vuejs-datepicker/dist/locale';


export default {
  name: 'teamlead-dock-suggestions',
  components: {Datepicker},
  mixins: [dataTables],
  data() {
    return {
      viewTriggers: 0,
      currentView: 'loading',
      nl: nl,
      selectedDate: new Date(),
      tableClass: 'table-striped table-bordered     responsive nowrap',
      tableInitOptions: {
        stateSave: true,
        language: {
          "lengthMenu": "_MENU_ resultaten weergeven",
          "zeroRecords": "Geen resultaten gevonden",
          "infoEmpty": "Geen resultaten om weer te geven",
          "search": "Zoeken:",
          "emptyTable": "Geen resultaten aanwezig in de tabel",
          "infoThousands": ".",
          "loadingRecords": "Een moment geduld aub - bezig met laden...",
          "paginate": {
            "first": "Eerste",
            "last": "Laatste",
            "next": "Volgende",
            "previous": "Vorige"
          },
          "aria": {
            "sortAscending": ": activeer om kolom oplopend te sorteren",
            "sortDescending": ": activeer om kolom aflopend te sorteren"
          },
          "autoFill": {
            "fill": "Vul alle cellen met <i>%d<\/i>",
            "fillHorizontal": "Vul cellen horizontaal",
            "fillVertical": "Vul cellen verticaal"
          },
          "buttons": {
            "collection": "Collectie",
            "colvis": "Kolom zichtbaarheid",
            "colvisRestore": "Herstel zichtbaarheid",
            "copy": "Kopieer",
            "copySuccess": {
              "1": "1 regel naar klembord gekopieerd",
              "_": "%ds regels naar klembord gekopieerd"
            },
            "copyTitle": "Kopieer naar klembord",
            "csv": "CSV",
            "excel": "Excel",
            "pageLength": {
              "-1": "Toon alle regels",
              "_": "Toon %d regels"
            },
            "pdf": "PDF",
            "print": "Print"
          },
          "info": "_START_ tot _END_ van _TOTAL_ regels",
          "infoFiltered": " (gefilterd uit _MAX_ regels)",
          "processing": "Verwerken..."
        },
        pageLength: 25,
        order: [[this.currentView === 'loading' ? 2 : 3, 'desc']]
      },
    };
  },
  computed: {
    ...mapGetters('dockSuggestions', ['getDockSuggestions']),
    ...mapGetters('users', ['getMeBasic']),
  },
  methods: {
    async printTable(){
      this.$store.commit('setLoading', true);


      await this.$FB.collection('print-dock-suggestions-queue').add({
        created_at: new Date(),
        created_by: this.getMeBasic.userId,
        companyId: this.getMeBasic.companyId,
        location: this.currentView,
        date: this.selectedDate,
        data: JSON.stringify($('#dock-suggestions-dt').DataTable().rows( {order:'index', search:'applied'} ).data().toArray()),
        translatedColumns: {
          truck: this.$t('shopfloor.teamlead.dockSuggestions.truck'),
          trailer: this.$t('shopfloor.teamlead.dockSuggestions.trailer'),
          reference: this.$t('shopfloor.teamlead.dockSuggestions.reference'),
          etd: this.$t('shopfloor.teamlead.dockSuggestions.etd'),
          eta: this.$t('shopfloor.teamlead.dockSuggestions.eta'),
          suggestionOne: this.$t('shopfloor.teamlead.dockSuggestions.suggestionOne'),
          suggestionTwo: this.$t('shopfloor.teamlead.dockSuggestions.suggestionTwo')
        }
      });
      this.$store.commit('setLoading', false)
      return this.$swal({
        customClass: {
          header: 'align-items-center'
        },
        toast: true,
        position: 'bottom-end',
        showConfirmButton: false,
        timer: 5000,
        type: 'success',
        title: this.$t('shopfloor.teamlead.dockSuggestions.printing')
      });
    },
    async viewChangeTriggered(event) {
      this.$store.commit('setLoading', true)
      await this.closeView();
      localStorage.setItem('orderhandling-view', this.currentView);
      this.$globalEventBus.$emit('orderhandling-view-changed', this.currentView);
      if (this.currentView === 'loading') {
        this.$router.push({name: 'teamlead-dock-suggestions-loading'}, () => {
          this.createView();
        });
      } else {
        this.$router.push({name: 'teamlead-dock-suggestions-unloading'}, () => {
          this.createView();
        })
      }
    },
    selectedDateChanged(date) {
      this.selectedDate = date;
      return this.openDockSuggestionsDBChannel(moment(this.selectedDate));
    },
    dateDisplay(date) {
      return moment(date).format('DD/MM/YY');
    },
    sortCaseInsensitive(a, b) {
      return `${a}`.toLowerCase().localeCompare(`${b}`.toLowerCase());
    },
    async openDockSuggestionsDBChannel(date) {
      let skipCloseDB = false;
      if (!date) {
        date = moment();
        skipCloseDB = true;
      }
      if (!skipCloseDB) {
        await this.$store.dispatch('dockSuggestions/closeDBChannel', {clearModule: true});
      }

      let where = [['companyId', '==', this.getMeBasic.companyId]]
      where.push(['date', '==', date.format('YYYY-MM-DD')]);
      where.push(['location', '==', this.currentView]);

      await this.$store.dispatch('dockSuggestions' + '/openDBChannel', {where})

      this.$store.commit('setLoading', false)

      this.viewTriggers++;
    },
    getColumns() {
      let self = this;
      return [
        {
          data: null,
          name: this.$t('shopfloor.teamlead.dockSuggestions.truck'),
          searchable: true,
          className: 'alignCenter',
          sortable: true,
          visible: true,
          render(data) {
            return data.truck ? data.truck : '';
          }
        },
        {
          data: null,
          name: this.$t('shopfloor.teamlead.dockSuggestions.trailer'),
          searchable: true,
          className: 'alignCenter',
          sortable: true,
          visible: true,
          render(data) {
            return data.trailer ? data.trailer : '';
          }
        },
        {
          data: null,
          name: this.$t('shopfloor.teamlead.dockSuggestions.reference'),
          searchable: true,
          className: 'alignCenter',
          sortable: true,
          visible: true,
          render(data) {
            let reference = '';
            if (data.truck) {
              reference += data.truck;
            }
            if (data.trailer) {
              if (reference.length > 0) {
                reference += ` - ${data.trailer}`;
              } else {
                reference = `${data.trailer}`;
              }
            }

            return reference.length > 0 ? reference : data.tripId;
          }
        },
        {
          data: null,
          name: this.currentView === 'loading' ? this.$t('shopfloor.teamlead.dockSuggestions.etd') : this.$t('shopfloor.teamlead.dockSuggestions.eta'),
          searchable: true,
          className: 'alignCenter',
          sortable: true,
          visible: true,
          render(data) {
            return data.estimatedTime ? moment(data.estimatedTime.toDate()).format('HH:mm:ss') : '';
          }
        },
        {
          data: null,
          name: this.$t('shopfloor.teamlead.dockSuggestions.suggestionOne'),
          searchable: true,
          className: 'alignCenter',
          sortable: true,
          visible: true,
          render(data) {
            if (data.zipCodeSuggestionsOne) {
              return (data.countrySuggestionOne === 'NL' ? '' : `<i>${data.countrySuggestionOne}</i> `) + `<b>${data.zipCodeSuggestionsOne}</b> <span class="percentage">(${Number(Math.round((data.percentageSuggestionOne*100)+'e1')+'e-1')}%)</span>`
            } else {
              return '';
            }
          }
        },
        {
          data: null,
          name: this.$t('shopfloor.teamlead.dockSuggestions.suggestionTwo'),
          searchable: true,
          className: 'alignCenter',
          sortable: true,
          visible: true,
          render(data) {
            if (data.zipCodeSuggestionsTwo) {
              return (data.countrySuggestionTwo === 'NL' ? '' : `<i>${data.countrySuggestionTwo}</i> `) + `<b>${data.zipCodeSuggestionsTwo}</b> <span class="percentage">(${Number(Math.round((data.percentageSuggestionTwo*100)+'e1')+'e-1')}%)</span>`
            } else {
              return '';
            }
          }
        }
      ]
    },
    async closeView(to) {
      return this.$store.dispatch('dockSuggestions/closeDBChannel',{clearModule:true});
    },
    async createView() {
      this.selectedRows = [];
      this.selectedDate = new Date();
      // this.currentView = this.$route.meta['view'];
      this.currentView = localStorage.getItem('orderhandling-view')

      return this.openDockSuggestionsDBChannel();
    }
  },
  watch: {},
  async beforeRouteLeave(to, from, next) {
    await this.closeView(to);
    next();
  },
  created() {
    this.$store.commit('setLoading', true)
    if (!localStorage.getItem('orderhandling-view')) {
      if (this.$route.params && this.$route.params.cargo && this.$route.params.cargo.cargoType === 'incoming') {
        localStorage.setItem('orderhandling-view', 'unloading')
        this.$globalEventBus.$emit('orderhandling-view-changed', 'unloading');
      } else {
        localStorage.setItem('orderhandling-view', 'loading');
        this.$globalEventBus.$emit('orderhandling-view-changed', 'loading');
      }
    } else {
      if (this.$route.params && this.$route.params.cargo) {
        if (this.$route.params.cargo.cargoType === 'incoming') {
          localStorage.setItem('orderhandling-view', 'unloading');
          this.$globalEventBus.$emit('orderhandling-view-changed', 'unloading');
        } else {
          localStorage.setItem('orderhandling-view', 'loading');
          this.$globalEventBus.$emit('orderhandling-view-changed', 'loading');
        }
      }
    }

    if (this.$route.params && this.$route.params.cargo) {
      this.defaultSelected.trailer = this.$route.params.cargo.trailerNumber;
      this.defaultSelected.truck = this.$route.params.cargo.truckNumber;
      this.defaultSelected.date = this.$route.params.cargo.estimatedTimeOfArrival ? this.$route.params.cargo.estimatedTimeOfArrival : this.$route.params.cargo.estimatedTimeOfDeparture;
    }
    this.createView();
  }
};
</script>


<style lang="scss">
.status-loading-idle {
  background-color: #ffa0a0;
}

.status-loading-busy {
  background-color: #ffaf46;
}

.status-loading-done {
  background-color: #00b954;
}


.status-unloading-idle {
  background-color: white;
  border: 1px solid black !important;
}

.status-unloading-busy {
  background-color: gray;
}

.status-unloading-done {
  background-color: #00c9ff;
}

.circle {
  width: 2rem;
  height: 2rem;
  border: 1px solid white;
  -moz-border-radius: 50px;
  -webkit-border-radius: 50px;
  border-radius: 50px;
}

.align-right-div {
  text-align: right;
  margin-top: 1rem;
  margin-bottom: 1rem;
}

.state-filter {
  display: grid;
  grid-template-columns: 13rem 2rem;;
  grid-template-rows: auto;
  grid-column-gap: 1rem;
  grid-row-gap: 0px;
}

.selection-buttons {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  grid-template-rows: 1fr;
  grid-column-gap: 1rem;
  grid-row-gap: 0px;
  margin-top: 1rem;
  margin-bottom: 1rem;
}

.dataTable-filters {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  grid-template-rows: repeat(2, auto);
  grid-column-gap: 1rem;
  grid-row-gap: 1rem;
  margin: 1rem;
  margin-left: 0rem;
  margin-right: 0rem;
}

.percentage {
  font-weight: normal !important;
}

.m-hide-lg {
  visibility: hidden;
  height: 0px;
}

.container-fluid {
  margin-bottom: 15px;
}

.reset-filter-button {
  margin-right: 1rem;
}

.blink-button {
  -webkit-animation: blink 5s infinite; /* Safari 4+ */
  -moz-animation: blink 5s infinite; /* Fx 5+ */
  -o-animation: blink 5s infinite; /* Opera 12+ */
  animation: blink 5s infinite; /* IE 10+, Fx 29+ */
}


.print-button {
  width: 5rem;
  height: 5rem;
  padding: 0;
  align-self: center;
  border-radius: 4px;
  justify-self: end;
}
</style>



